import { Post } from "./types/client";

export const getHeader = ({ post }: { post: Post }) => {
  //TODO: implement startpage detection
  //TODO: add headers depending on project
  switch (post.type) {
    case "page":
      if ("header_startseite" in post.acf) {
        return post.acf?.header_startseite;
      }
      return post.acf?.header_seite;
    case "catalog":
      return post.acf?.header_catalog;
    case "team":
      return post.acf?.header_team;
    case "glossary":
      return post.acf?.header_glossary;
    case "events":
      return post.acf?.header_events;
    case "quotes":
      return post.acf?.header_quotes;
    case "logos":
      return post.acf?.header_logos;
    case "magazine":
      return post.acf?.header_magazine;
    case "blog":
      return post.acf?.header_post;
    case "videos":
      return post.acf?.header_videos;
    case "audios":
      return post.acf?.header_audios;
    case "noble_elements":
      if ("header_startseite" in post.acf) {
        return post.acf?.header_startseite;
      }
      return post.acf?.header_seite;
    case "jobs":
      return post.acf.header_job;
    case "metals":
      return post.acf.header_metal;
    case "press":
      return post.acf.header_press;
    case "faq":
      return post.acf.header_faq;
    case "forms":
    case "presets_forms":
      return post.acf.form;
    default:
      throw new Error("unknown post type");
  }
};

export const getTitle = ({ post }: { post: Post }) => {
  const header = getHeader({ post });
  if ("title" in header) {
    return header.title;
  }
  return post.title.rendered;
};
